module.exports = "../../static/img/alarm-white.4f4f7e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/alarm-white.png
// module id = 79
// module chunks = 0